<template>
  <div class="w-25">
    <div class="container-image">
      <div v-if="!displayedImage" class="icon-container">
        <img src="~@/assets/icon/add-image-gray.svg" alt="icon upload image" />
      </div>
      <p v-if="!displayedImage">Image 1</p>
      <div v-else class="displayed-image">
        <img :src="displayedImage" alt="uploaded image"  />
      </div>
    </div>
    <div class="d-flex items-center mt-3" style="gap: 10px">
      <custom-button :buttonStyle="{flex: 1}" @click="handleTogleUpload"> Browse </custom-button>
      <custom-button :buttonStyle="{flex: 1}" color="red" @click="handleRemove"> Remove </custom-button>
    </div>
    <input type="file" ref="inputImage" hidden @change="handleClickUploadImage" />
  </div>
</template>

<script>
import { CustomButton } from "../../Button";

export default {
  name: "UploadImage",
  components: { CustomButton },
  props: {
    value: {
      type: Object,
      default: () => ({
        imgFileName: "",
        imgBase64: "",
        imgUrl: "",
        photoId:0
      }),
    },
  },
  data() {
    return {
      displayedImage: null,
    };
  },
  methods: {
    handleTogleUpload() {
      this.$refs.inputImage.click();
    },
    handleClickUploadImage(event) {
      const file = event.target.files[0];
      this.displayedImage = URL.createObjectURL(file);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const data = {
          imgFileName: file.name,
          imgBase64: reader.result.split(",")[1],
          imgUrl: reader.result,
          photoId:0
        }
        this.$emit("filePicked", data);
      };
    },
    handleRemove() {
      this.displayedImage = null;
      this.$refs.inputImage.value = null;
      this.$emit("filePicked", null);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.imgUrl) {
          this.displayedImage = newVal.imgUrl;
        } else {
          this.displayedImage = null;
        }
      },
    },
  }
};
</script>

<style scoped>
.icon-container {
  width: 80px;
  height: 80px;
  background-color: #f0f1f2;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-image {
  border: 1px dashed #cfd3d9;
  background-color: #f8f9fa;
  border-radius: 12px;
  min-height: 172px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
}

.container-image p {
  color: #bcbdbe;
  font-size: 12px;
  margin: 10px 0;
}

.displayed-image {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.displayed-image img {
  /* height: 172px; */
  width: 100%;
  max-height: 172px;
  aspect-ratio: 1/1;
  object-fit: cover
}
</style>


// WEBPACK FOOTER //
// src/components/Catalog/Components/UploadImage.vue